"use client";

import {JSX, memo} from "react";

import RcPagination from "rc-pagination";
import {useSnapshot} from "valtio";

import {type PaginationInstance} from "@/shared/models/pagination";
import {Typography} from "@/shared/ui/data-display/typography";

import "./styles/pagination.scss";
import "rc-pagination/assets/index.css";

interface PaginationProps {
    model: PaginationInstance;
    className?: string;
    simple?: boolean;
    showLessItems?: boolean;
}

export const Pagination = memo(function Pagination({model, className, simple = false, showLessItems = false}: PaginationProps): JSX.Element | null {
    const snapshot = useSnapshot(model);

    const handleChange = (page: number): void => {
        model.setPage(page);
    };

    const handleShowSizeChange = (_current: number, size: number): void => {
        model.setPageSize(size);
    };

    const showTotal = (total: number, range: [number, number]): JSX.Element => {
        return (
            <Typography as="span" size={14} weight={400} color="paragraph">
                {range[0]}-{range[1]} of {total}
            </Typography>
        );
    };

    if (snapshot.total === 0) {
        return null;
    }

    return (
        <div className={`pagination-wrapper ${className || ""}`}>
            <RcPagination
                current={snapshot.current}
                pageSize={snapshot.pageSize}
                total={snapshot.total}
                onChange={handleChange}
                onShowSizeChange={handleShowSizeChange}
                pageSizeOptions={model.pageSizeOptions}
                showSizeChanger={model.showSizeChanger}
                showQuickJumper={model.showQuickJumper}
                showTotal={model.showTotal ? showTotal : undefined}
                disabled={snapshot.disabled}
                simple={simple}
                showLessItems={showLessItems}
                locale={{
                    items_per_page: "/ page",
                    jump_to: "",
                    jump_to_confirm: "confirm",
                    page: "",
                    prev_page: "Previous Page",
                    next_page: "Next Page",
                    prev_5: "Previous 5 Pages",
                    next_5: "Next 5 Pages",
                    prev_3: "Previous 3 Pages",
                    next_3: "Next 3 Pages",
                }}
            />
        </div>
    );
});
